import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";
//
import cmsHubMembershipApi from "api/membershipApi";
import TableContainer from "components/Common/TableContainer";
import { catchAsync, formatDate, formatNumber, formatWithKoreanAmPm } from "helpers/general";
import moment from "moment";

interface Props {
  isOpen: boolean;
  id: number;
  onClose: () => void;
}

const ModalHistoryTrafic = (props: Props) => {
  const { t } = useTranslation();
  const [rows, setRows] = useState<Array<any>>([]);

  const columns = [
    {
      Header: t("media.start_date"),
      // Rows are monthly buckets built at runtime and have no `id` — use `start_date`
      // as the identity, see the superadmin-api list `id` changes
      accessor: "start_date",
      sortable: false,
      thWidth:50,
      thClass: "text-center",
      Cell: ({ row }: any) => (
        <div className="text-center">
          {row?.original?.start_date
            ? moment(row?.original?.start_date).format("YYYY.MM")
            : "-"}
        </div>
      ),
    },
    {
      Header: t("membership.period"),
      accessor: "name",
      sortable: false,
      thWidth:80,
      thClass: "text-left",
      Cell: ({ row }: any) => {
        return (
          <div className="text-left">
            {[moment(row?.original?.start_date).format("YYYY.MM.DD"),moment(row?.original?.end_date).format("YYYY.MM.DD")].join(" ~ ")}
          </div>
        );
      },
    },
    {
      Header: t("membership.daily_average_PV"),
      accessor: "created_at",
      sortable: false,
      thWidth:150,
      thClass: "text-right",
      Cell: ({ row }: any) => {
        return (
          <div className="text-right">
            {formatNumber(row?.original?.daily_pv)}
          </div>
        );
      },
    },
    {
      Header: t("membership.monthly_average_PV"),
      accessor: "note",
      sortable: false,
      thClass: "text-right",
      Cell: ({ row }: any) => {
        return (
          <div className="text-right">
            {formatNumber(row?.original?.monthly_pv)}
          </div>
        );
      },
    },
  ];

  const getHistory = async () => {
    const [err, result] = await catchAsync(
      cmsHubMembershipApi.cmshubCompanyPlanTrafficHistory(props.id)
    );

    if (err) {
      console.log(err);
      return;
    }
    setRows(result?.data);
  };
  useEffect(() => {
    if (props.id && props.isOpen) {
      getHistory();
    } else {
      setRows([]);
    }
  }, [props.id, props.isOpen]);

  return (
    <Modal
      isOpen={props.isOpen}
      centered={true}
      scrollable={false}
      style={{ width: "606px",maxWidth:"606px" }}
    >
      <div className="d-flex justify-content-between pt-3 pb-2 px-3 items-center">
        <div></div>
        <div style={{ fontSize: "18px", fontWeight: "700" }}>
          {t("membership.traffic_history")}
        </div>
        <div onClick={() => props.onClose()}>
          <i
            className="ri-close-line"
            style={{ fontSize: "20px", cursor: "pointer" }}
          ></i>
        </div>
      </div>
      <ModalBody>
        <div style={{ minHeight: "500px" }}>
          <TableContainer
            columns={columns}
            data={rows || []}
            customPageSize={rows?.length}
            customPageIndex={rows?.length}
            totalRecords={rows?.length}
            customPageCount={1}
            className="custom-header-css"
            divClass="table-responsive table-card h-100"
            tableClass="align-middle"
            theadClass="table-light align-middle"
            isShowPagination={false}
            messageEmpty={t("membership.there_is_no_history")}
            heightEmpty="437px"
          />
        </div>
        <div className="hstack gap-2 mt-3 justify-content-center px-5">
          <button
            className="btn btn-soft-secondary fs-14"
            type="button"
            color="light"
            style={{ width: "150px" }}
            onClick={() => props?.onClose()}
          >
            {t("cms_media.cancellation")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalHistoryTrafic;
